import _decorate from "@babel/runtime/helpers/esm/decorate";
let _ = t => t,
  _t;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from "././card.css.js";
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
const {
  stablePrefix: c4dPrefix
} = settings;

/**
 * The eyebrow content of card.
 *
 * @element c4d-card-eyebrow
 */
let C4DCardEyebrow = _decorate([customElement(`${c4dPrefix}-card-eyebrow`)], function (_initialize, _StableSelectorMixin) {
  class C4DCardEyebrow extends _StableSelectorMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DCardEyebrow,
    d: [{
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "slot",
      value() {
        return 'eyebrow';
      }
    }, {
      kind: "method",
      key: "render",
      value:
      /**
       * The shadow slot this card eyebrow should be in.
       */

      function render() {
        return html(_t || (_t = _` <slot></slot> `));
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--card-eyebrow`;
      }

      // `styles` here is a `CSSResult` generated by custom WebPack loader
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value() {
        return styles;
      }
    }]
  };
}, StableSelectorMixin(LitElement));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardEyebrow;
//# sourceMappingURL=card-eyebrow.js.map
